import NewPasswordComponents from 'components/NewPasswordComponents'

function NewPassword() {
  return <NewPasswordComponents />
}

export default NewPassword
